<template>

        <div class="c-avatar ml-3" style="width: 45px;height: 45px" @click="go_profile">
          <div :style="`background:center /cover no-repeat url(${user_image});width: 45px;height: 45px;`"
               class="c-avatar-img "
          >

          </div>

        </div>
  
</template>

<script>
export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return {
      itemsCount: 42,
      user_name: "",
      user_image: "/img/user.png",
    }
  },
  methods:{
      go_profile(){

          this.$router.push({ path: '/dashboard/users/profile'});
      },
        get_user_name(){


            this.user_name= localStorage.getItem("user_name")
            // this.user_image= this.$store.state.user_image;



            // alert(res.contains("Sam"));

          // this.$router.push({ path: '/login'});
      }
    },computed: {

    },
  mounted() {
    this.user_image =  localStorage.getItem('image');

        setTimeout(() =>
            this.get_user_name()
            , 1000);

    }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>
